export const bnbStars = [
  "500",
  "450",
  "400",
  "375",
  "350",
  "325",
  "300",
  "280",
  "260",
  "240",
  "220",
  "220",
  "220",
  "220",
  "220",
  "200",
  "200",
  "200",
  "200",
  "200",
  "180",
  "180",
  "180",
  "180",
  "180",
  "160",
  "160",
  "160",
  "160",
  "160",
  "150",
  "150",
  "150",
  "150",
  "150",
  "140",
  "140",
  "140",
  "140",
  "140",
  "130",
  "130",
  "130",
  "130",
  "130",
  "120",
  "120",
  "120",
  "120",
  "120",
  "110",
  "110",
  "110",
  "110",
  "110",
  "100",
  "100",
  "100",
  "100",
  "100",
  "95",
  "95",
  "95",
  "95",
  "95",
  "90",
  "90",
  "90",
  "90",
  "90",
  "85",
  "85",
  "85",
  "85",
  "85",
  "80",
  "80",
  "80",
  "80",
  "80",
  "75",
  "75",
  "75",
  "75",
  "75",
  "70",
  "70",
  "70",
  "70",
  "70",
  "65",
  "65",
  "65",
  "65",
  "65",
  "60",
  "60",
  "60",
  "60",
  "60",
];
export const vanarStars = [
  "500",
  "450",
  "400",
  "375",
  "350",
  "325",
  "300",
  "280",
  "260",
  "240",
  "220",
  "220",
  "220",
  "220",
  "220",
  "200",
  "200",
  "200",
  "200",
  "200",
  "180",
  "180",
  "180",
  "180",
  "180",
  "160",
  "160",
  "160",
  "160",
  "160",
  "150",
  "150",
  "150",
  "150",
  "150",
  "140",
  "140",
  "140",
  "140",
  "140",
  "130",
  "130",
  "130",
  "130",
  "130",
  "120",
  "120",
  "120",
  "120",
  "120",
  "110",
  "110",
  "110",
  "110",
  "110",
  "100",
  "100",
  "100",
  "100",
  "100",
  "95",
  "95",
  "95",
  "95",
  "95",
  "90",
  "90",
  "90",
  "90",
  "90",
  "85",
  "85",
  "85",
  "85",
  "85",
  "80",
  "80",
  "80",
  "80",
  "80",
  "75",
  "75",
  "75",
  "75",
  "75",
  "70",
  "70",
  "70",
  "70",
  "70",
  "65",
  "65",
  "65",
  "65",
  "65",
  "60",
  "60",
  "60",
  "60",
  "60",
];

export const skaleStars = [
  "300",
  "275",
  "250",
  "225",
  "200",
  "180",
  "160",
  "140",
  "130",
  "120",
  "110",
  "110",
  "110",
  "110",
  "110",
  "100",
  "100",
  "100",
  "100",
  "100",
  "90",
  "90",
  "90",
  "90",
  "90",
  "80",
  "80",
  "80",
  "80",
  "80",
  "75",
  "75",
  "75",
  "75",
  "75",
  "70",
  "70",
  "70",
  "70",
  "70",
  "65",
  "65",
  "65",
  "65",
  "65",
  "60",
  "60",
  "60",
  "60",
  "60",
  "55",
  "55",
  "55",
  "55",
  "55",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
];

export const taikoStars = [
  "450",
  "400",
  "350",
  "325",
  "300",
  "275",
  "250",
  "230",
  "210",
  "190",
  "170",
  "170",
  "170",
  "170",
  "170",
  "150",
  "150",
  "150",
  "150",
  "150",
  "135",
  "135",
  "135",
  "135",
  "135",
  "120",
  "120",
  "120",
  "120",
  "120",
  "110",
  "110",
  "110",
  "110",
  "110",
  "100",
  "100",
  "100",
  "100",
  "100",
  "95",
  "95",
  "95",
  "95",
  "95",
  "90",
  "90",
  "90",
  "90",
  "90",
  "85",
  "85",
  "85",
  "85",
  "85",
  "80",
  "80",
  "80",
  "80",
  "80",
  "75",
  "75",
  "75",
  "75",
  "75",
  "70",
  "70",
  "70",
  "70",
  "70",
  "65",
  "65",
  "65",
  "65",
  "65",
  "60",
  "60",
  "60",
  "60",
  "60",
  "55",
  "55",
  "55",
  "55",
  "55",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
];

export const matStars = [
  "400",
  "360",
  "325",
  "300",
  "275",
  "250",
  "225",
  "200",
  "180",
  "160",
  "140",
  "140",
  "140",
  "140",
  "140",
  "120",
  "120",
  "120",
  "120",
  "120",
  "110",
  "110",
  "110",
  "110",
  "110",
  "100",
  "100",
  "100",
  "100",
  "100",
  "90",
  "90",
  "90",
  "90",
  "90",
  "80",
  "80",
  "80",
  "80",
  "80",
  "75",
  "75",
  "75",
  "75",
  "75",
  "70",
  "70",
  "70",
  "70",
  "70",
  "65",
  "65",
  "65",
  "65",
  "65",
  "60",
  "60",
  "60",
  "60",
  "60",
  "55",
  "55",
  "55",
  "55",
  "55",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
];

export const seiStars = [
  "400",
  "360",
  "325",
  "300",
  "275",
  "250",
  "225",
  "200",
  "180",
  "160",
  "140",
  "140",
  "140",
  "140",
  "140",
  "120",
  "120",
  "120",
  "120",
  "120",
  "110",
  "110",
  "110",
  "110",
  "110",
  "100",
  "100",
  "100",
  "100",
  "100",
  "90",
  "90",
  "90",
  "90",
  "90",
  "80",
  "80",
  "80",
  "80",
  "80",
  "75",
  "75",
  "75",
  "75",
  "75",
  "70",
  "70",
  "70",
  "70",
  "70",
  "65",
  "65",
  "65",
  "65",
  "65",
  "60",
  "60",
  "60",
  "60",
  "60",
  "55",
  "55",
  "55",
  "55",
  "55",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
];


export const mantaStars = [
  "400",
  "360",
  "325",
  "300",
  "275",
  "250",
  "225",
  "200",
  "180",
  "160",
  "140",
  "140",
  "140",
  "140",
  "140",
  "120",
  "120",
  "120",
  "120",
  "120",
  "110",
  "110",
  "110",
  "110",
  "110",
  "100",
  "100",
  "100",
  "100",
  "100",
  "90",
  "90",
  "90",
  "90",
  "90",
  "80",
  "80",
  "80",
  "80",
  "80",
  "75",
  "75",
  "75",
  "75",
  "75",
  "70",
  "70",
  "70",
  "70",
  "70",
  "65",
  "65",
  "65",
  "65",
  "65",
  "60",
  "60",
  "60",
  "60",
  "60",
  "55",
  "55",
  "55",
  "55",
  "55",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
];

export const baseStars = [
  "360",
  "325",
  "300",
  "275",
  "250",
  "230",
  "210",
  "190",
  "170",
  "150",
  "130",
  "130",
  "130",
  "130",
  "130",
  "110",
  "110",
  "110",
  "110",
  "110",
  "100",
  "100",
  "100",
  "100",
  "100",
  "90",
  "90",
  "90",
  "90",
  "90",
  "80",
  "80",
  "80",
  "80",
  "80",
  "75",
  "75",
  "75",
  "75",
  "75",
  "70",
  "70",
  "70",
  "70",
  "70",
  "65",
  "65",
  "65",
  "65",
  "65",
  "60",
  "60",
  "60",
  "60",
  "60",
  "55",
  "55",
  "55",
  "55",
  "55",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
  "50",
];

export const monthlyStarPrizes = [
  400, 200, 150, 80, 80, 40, 40, 40, 40, 40, 25, 25, 25, 25, 25, 25, 25,
  25, 25, 25, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 10, 10, 10, 10, 10, 10,
  10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10,
  10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 5, 5, 5, 5,
  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
  5, 5, 5, 5, 5, 5, 5,
];

export const monthlyExtraStarPrizes = [
  500, 300, 200, 100, 100, 65, 65, 65, 65, 65, 35, 35, 35, 35, 35, 35, 35,
  35, 35, 35, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 20, 20, 20, 20, 20, 20,
  20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
  20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 15, 15, 15, 15,
  15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15,
  15, 15, 15, 15, 15, 15, 15,
];

export const weeklyStarPrizes = [
  30, 25, 20, 15, 15, 10, 10, 10, 10, 10, 8, 8, 8, 8, 8, 8, 8, 8, 8,
  8, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
  4, 4, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  2, 2, 2, 2, 2, 2, 2,
];

export const weeklyExtraStarPrizes = [
  40, 35, 30, 25, 25, 20, 20, 20, 20, 20, 10, 10, 10, 10, 10, 10, 10, 10, 10,
  10, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6,
  6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6,
  6, 6, 6, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  3, 3, 3, 3, 3, 3, 3,
];
